import { useAdminContext } from "../../contexts";
import NavDropdown from "react-bootstrap/NavDropdown";
import "../../styles/Navbar.css";

const AdminDropdown = () => {
  const { selectedCustomer, updateSelectedCustomer, customers } =
    useAdminContext();

  return (
    <NavDropdown
      title={`Viewing as ${selectedCustomer.customer}`}
      id='dropdownMenuAdmin'
      className='text-center d-flex flex-column'
    >
      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
        <NavDropdown.Item
          key='Admin'
          onClick={() => updateSelectedCustomer({ customer: "Admin" })}
          active={selectedCustomer.customer === "Admin"}
        >
          Admin
        </NavDropdown.Item>
        {customers?.map((customer) => (
          <NavDropdown.Item
            key={customer._id}
            onClick={() => updateSelectedCustomer(customer)}
            active={selectedCustomer.customer === customer.customer}
          >
            {customer.customer}
          </NavDropdown.Item>
        ))}
      </div>
    </NavDropdown>
  );
};
export default AdminDropdown;
